export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 8_04.813535ed.jpg";